import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import { withRouter } from "react-router-dom";
import uuid from 'uuid/v1';
import moment from 'moment';
import  Page  from '../../components/Page';
import {  SearchBar } from '../../components';
import { NetworkContext } from '../../context/NetworkContext';

import { Header, Results } from './components';
import { SnackBarContext } from '../../context/SnackbarContext';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    maxWidth: '100%',
    padding: theme.spacing(3)
  },
  results: {
    marginTop: theme.spacing(3)
  }
}));
export const SurveyList = withRouter(props => {

  const classes = useStyles();
  const [orders, setOrders] = useState([
    
  ]);
  const [totalcount, setTotalcount] = useState(null);
  const { sendNetworkRequest } = React.useContext(NetworkContext);
  const snackbarCtx = React.useContext(SnackBarContext);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  async function fetchallsurvey()
  {
    let bodycontent = {
        page: page * rowsPerPage,
        limit: rowsPerPage
    }
    let ads = await sendNetworkRequest('/admin/getsurvey', {}, bodycontent,false)
    
    setTotalcount(ads?.module?.length??0)
    setOrders(ads?.module || [])
  }
  async function updatesurveystatus(survey, nextStatus)
  {
    const result = await sendNetworkRequest('/admin/updatesurveystatus', {}, {
      id: survey.id,
      status: nextStatus
    }, false)
    snackbarCtx.setSnack({
      ...snackbarCtx,
      open: true,
      type: result?.status === 'success' ? 'success' : 'error',
      msg: result?.message || (nextStatus ? 'Survey activated' : 'Survey deactivated'),
      vertical: 'top',
    });
    fetchallsurvey()
  }
  function onPageChange(page)
  {
    setPage(page)
  }
  function onPageLimit(limit)
  {
    setRowsPerPage(limit)
  }
  useEffect(() => {
    fetchallsurvey()
 
  }, [page,rowsPerPage]);

  return (
    <Page
      className={classes.root}
      title="Survey"
    >
      <Header />
       <SearchBar /> 
      <Results
        className={classes.results}
        orders={orders} //
        totalcount={totalcount}
        onPageChange={onPageChange}
        onPageLimit={onPageLimit}
        onStatusChange={updatesurveystatus}
      />
     
    </Page>
  );
});

export default SurveyList;
